
import React from "react";
import { AlertCircle } from "lucide-react";

export default function SubscriptionInvalidPage() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 px-4">
      <div className="bg-white shadow-lg rounded-xl p-32 max-w-md text-center border border-red-300">
        <div className="flex justify-center mb-16">
          <AlertCircle className="text-red-600 w-12 h-12" />
        </div>
        <h2 className="text-2xl font-semibold text-gray-800 mb-8">
          Subscription Expired
        </h2>
        <p className="text-gray-700 font-medium">
          Your access is currently restricted because your subscription is no longer active.
        </p>
        <p className="text-gray-700 mt-16 font-medium">
          Please contact your administrator to renew your subscription or for further assistance.
        </p>
      </div>
    </div>
  );
}